import React from "react";
import GOIFieldInteger from "./GOIFieldInteger";
import GOIFieldFloat from "./GOIFieldFloat";
import GOIFieldBoolean from "./GOIFieldBoolean";
import GOIFieldFile from "./GOIFieldFile";
import GOIFieldTimestamp from "./GOIFieldTimestamp";
import GOIFieldString from "./GOIFieldString";
import GOIFieldTime from "./GOIFieldTime";
import GOIFieldDate from "./GOIFieldDate";
import GOIFieldMultipleChoices from "./GOIFieldMultipleChoices";
import "./index.css";

const UnKnownField = () => {
  return (
    <div className="p-15">
      <p>Unknown Type: unable to display</p>
    </div>
  );
};

// Mapping of class names to components
const componentMapping = {
  File: GOIFieldFile,
  Integer: GOIFieldInteger,
  Float: GOIFieldFloat,
  String: GOIFieldString,
  Time: GOIFieldTime,
  Date: GOIFieldDate,
  Boolean: GOIFieldBoolean,
  SingleChoice: GOIFieldMultipleChoices,
  Timestamp: GOIFieldTimestamp,
  default: UnKnownField,
};

// generates a specific input field based on the class property of the node
const GOI = ({ editMode, inputData, value }) => {
  // Destructure inputData and options
  const { class: className } = inputData;

  // Get the component from the mapping using the class name, or default to GOIInputField
  const Component = componentMapping[className] || componentMapping.default;

  return (
    <div className="goi-input-field-wrapper">
      <Component disabled={!editMode} value={value} inputData={inputData} />
    </div>
  );
};

export default GOI;
